module.exports = __webpack_public_path__ + "img/open-posi-tri.8fbb35b8.svg";